import PluginMember from './PluginMember';
import './style/index.less';

export { default as PluginMemberSelect } from './components/plugin-member-select';

export default PluginMember;
